__turbopack_context__.v({
  "art": "az5faq_art",
  "artNarrow": "az5faq_artNarrow",
  "artWide": "az5faq_artWide",
  "benefit": "az5faq_benefit",
  "body": "az5faq_body",
  "bodyNarrow": "az5faq_bodyNarrow",
  "bodyWide": "az5faq_bodyWide",
  "card": "az5faq_card",
  "cardBlock": "az5faq_cardBlock",
  "chip": "az5faq_chip",
  "chipCheck": "az5faq_chipCheck",
  "chipLabel": "az5faq_chipLabel",
  "chipScattered": "az5faq_chipScattered",
  "covered": "az5faq_covered",
  "coveredTitle": "az5faq_coveredTitle",
  "covers": "az5faq_covers",
  "description": "az5faq_description",
  "disclaimer": "az5faq_disclaimer",
  "divider": "az5faq_divider",
  "headBlock": "az5faq_headBlock",
  "header": "az5faq_header",
  "item": "az5faq_item",
  "itemCopy": "az5faq_itemCopy",
  "itemDescription": "az5faq_itemDescription",
  "itemIcon": "az5faq_itemIcon",
  "itemTitle": "az5faq_itemTitle",
  "itemTitleRow": "az5faq_itemTitleRow",
  "list": "az5faq_list",
  "modal": "az5faq_modal",
  "note": "az5faq_note",
  "noteNarrow": "az5faq_noteNarrow",
  "noteWide": "az5faq_noteWide",
  "price": "az5faq_price",
  "subtitle": "az5faq_subtitle",
  "title": "az5faq_title",
  "uhxInfoDescription": "az5faq_uhxInfoDescription",
  "uhxPricingModal": "az5faq_uhxPricingModal",
});
